import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        stroke={theme.palette.action.active}
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M11.775 20.675h-6.5a1 1 0 0 1-1-1v-15.4a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v4.1m-12.3-.9h9.6m-9.6 3.6h4.8m7.133 6.834a3.3 3.3 0 1 0-4.667-4.667 3.3 3.3 0 0 0 4.668 4.667Zm0 0 3.067 3.066"
      />
    </svg>
  );
};
